import React, { FC, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Icon from '../../components/icon/Icon';
import Logo from '../../components/Logo';
import LogoCollapse from '../../components/LogoCollapse';
import { motion } from 'framer-motion';
import { useUser } from '../../contexts/UserContext';

interface IBrandProps {
	asideStatus: boolean;
	setAsideStatus(...args: unknown[]): unknown;
}

const Brand: FC<IBrandProps> = ({ asideStatus, setAsideStatus }) => {

	const { isPremium } = useUser();
	return (
		<div className='brand'>
			{asideStatus && (
				<motion.div
					className='brand-logo'
					style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '32px' }}
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					transition={{ duration: 0.5 }}
				>
					<h1 className='brand-title' style={{ margin: 0 }}>
						<Link to='/' aria-label='Logo'>
							<Logo height={32} className="sidebar-logo mt-3" isPremium={isPremium} />
						</Link>
					</h1>
				</motion.div>
			)}
			<button
				type='button'
				className='btn brand-aside-toggle'
				aria-label='Toggle Aside'
				onClick={() => setAsideStatus(!asideStatus)}>
				<Icon icon='FirstPage' className='brand-aside-toggle-close' />
				<Icon icon='LastPage' className='brand-aside-toggle-open' />
			</button>
		</div>
	);
};

Brand.propTypes = {
	asideStatus: PropTypes.bool.isRequired,
	setAsideStatus: PropTypes.func.isRequired,
};

export default Brand;
